import * as yup from 'yup';

const WeekendSchema = () =>
  yup.object().shape({
    favoriteVacationSpots: yup.array(),
    favoriteSportsToPlay: yup.array(),
    favoriteSportsToWatch: yup.array(),
    favoriteBooks: yup.array(),
    favoriteShows: yup.array(),
  });

export default WeekendSchema;
